export const apiJson = {
  dependent_object_version: 'V1',
  include_auto_created_objects: false,
  include_dependent_objects: false,
  dependent_objects_record_size: 50,
  include_details: false,
  include_headers: true,
  include_hidden_objects: false,
  include_incomplete_objects: false,
  include_visualization_headers: false,
  record_offset: 0,
  record_size: 50,
  include_stats: false,
  include_discoverable_objects: false,
  show_resolved_parameters: false,
  liveboard_response_version: 'V1',
  include_only_published_objects: false,
  sort_options: {
    field_name: 'DISPLAY_NAME',
    order: 'ASC',
  },
};
